export const GA_TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// export const gtag = (...args) => {
//   window.gtag && window.gtag(...args);
// };

// Safely trigger gtag events
export const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

let user_id = undefined;
try {
  const matUserData = localStorage.getItem('MAT-User');
  if (matUserData) {
    const matUserObject = JSON.parse(matUserData);
    user_id = matUserObject?.user_details?.user_id || undefined;
  }
} catch (e) {
  console.warn('User data not found or invalid in localStorage');
}

export const initGA = () => {
  const stored = localStorage.getItem('eliteConsent');
  if (!stored) return;
  const { analytics } = JSON.parse(stored);
  if (!analytics) return;

  if (!GA_TRACKING_ID) {
    console.warn('GA_TRACKING_ID not found in environment variables');
    return;
  }
  // Initialize dataLayer FIRST
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };
  // Call gtag with initial setup
  gtag('js', new Date());
  // Dynamically load the gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);
  // Configure GA after script loads or immediately if gtag is available
  script.onload = () => {
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
      user_id: user_id,
      cookie_flags: 'SameSite=None;Secure' // optional for stricter cookies
    });
  };
  // Fallback: configure immediately (in case script loads faster)
  gtag('config', GA_TRACKING_ID, {
    page_title: document.title,
    page_location: window.location.href,
    user_id: user_id,
    cookie_flags: 'SameSite=None;Secure' // optional for stricter cookies
  });
};

export const pageview = (url) => {
  if (localStorage.getItem('cookieConsent') !== 'true') return;
  if (!GA_TRACKING_ID) return;
  gtag('config', GA_TRACKING_ID, {
    page_path: url,
    user_id: user_id
  });
};

export const event = ({ action, category, label, value }) => {
  if (localStorage.getItem('cookieConsent') !== 'true') return;
  if (!GA_TRACKING_ID) return;
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
    user_id: user_id
  });
};
